import { configureStore } from "@reduxjs/toolkit";

import appReducer from "../features/app/appSlice";
import loginReducer from "../features/login/loginSlice";
import dashboardReducer from "../features/dashboard/dashboardSlice";

const store = configureStore({
  reducer: {
    loginState: loginReducer,
    appState: appReducer,
    dashboardState: dashboardReducer,
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware(),
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type IAppState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
